import React from 'react';
import { TextValidator } from 'react-material-ui-form-validator';

import { usePageStore } from '@client/store/pageStore/context/pageContext';
import i18n from '@client/utils/i18n';
import { RecipeSection } from '@ledium/types';
import { Grid } from '@mui/material';
import InputLabel from '@mui/material/InputLabel';

interface SectionRepeatNumInputProps {
    sectionData: RecipeSection;
    onChange: React.ChangeEventHandler<HTMLInputElement>;
}

const SectionRepeatNumInput = ({ sectionData, onChange }: SectionRepeatNumInputProps) => {
    const {
        pageState: { formData }
    } = usePageStore();

    return (
        <Grid item xs={4}>
            {formData.readOnly ? (
                <div>
                    {i18n('circadian_repeat_time')}: {sectionData.repeatNum}
                </div>
            ) : (
                <>
                    <InputLabel shrink id="section-editor-circadian-repeatNum">
                        {i18n('circadian_repeat_time')}
                    </InputLabel>
                    <TextValidator
                        name="repeatNum"
                        variant="outlined"
                        onChange={onChange}
                        type="number"
                        min="1"
                        max="500"
                        value={sectionData.repeatNum}
                        validators={['required']}
                        errorMessages={[i18n('this_field_is_required')]}
                    />
                </>
            )}
        </Grid>
    );
};

export default SectionRepeatNumInput;
